'use client';

import React from 'react';
import Sidebar from '@/components/Sidebar';
import GlobalPeopleSearch from '@/components/GlobalPeopleSearch';
import PushNotifications from '@/components/PushNotifications';
import { Toaster } from 'sonner';
import { useTheme } from '@/context/ThemeContext';

// import AIAnalysisBubble from '@/components/AIAnalysisBubble';

export default function AppLayout({ children }: { children: React.ReactNode }) {
  const { theme } = useTheme();

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      {/* Ambient background blobs for depth */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden z-0">
        <div className="blob-primary absolute -top-32 -left-32 w-96 h-96 opacity-60" />
        <div className="blob-green absolute bottom-0 right-0 w-80 h-80 opacity-40" />
        <div className="blob-cyan absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 opacity-20" />
      </div>
      <Sidebar />
      {/* On mobile: pt-14 for fixed top header, pb-20 for fixed bottom nav */}
      <main className="relative z-10 min-w-0 flex-1 overflow-y-auto scrollbar-thin pt-14 pb-24 lg:pt-0 lg:pb-0">
        <header className="hidden lg:flex sticky top-0 z-30 justify-end border-b border-border/60 bg-card/95 px-6 py-2 backdrop-blur-xl">
          <GlobalPeopleSearch />
        </header>
        <div className="w-full max-w-lg mx-auto px-4 py-4 lg:max-w-none lg:px-6 xl:px-8 lg:py-6">
          <PushNotifications silent />
          {children}
        </div>
      </main>
      {/* Temporarily hidden: uncomment this and the import to restore the AI robot. */}
      {/* <AIAnalysisBubble /> */}
      <Toaster
        position="bottom-right"
        theme={theme}
        toastOptions={{
          style: {
            background: 'var(--card)',
            border: '1px solid var(--border)',
            color: 'var(--foreground)',
            boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
          },
        }}
      />
    </div>
  );
}
